module.exports = __webpack_public_path__ + "img/preview_excel.be3aef67.png";